import FileSaver from "file-saver";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../components/toastify";
import { AxiosGetMethod } from "../helpers/customAxios";
import { setShowPreloader } from "../store/activePage";
import HandleLogout from "./handleLogout";

const handleExportReport = async (event_id, dispatch) => {
  dispatch(setShowPreloader(true));
  const ExportReport = await AxiosGetMethod(
    `org/event/export?event_id=${event_id}`
  );
  dispatch(setShowPreloader(false));
  console.log("ExportReport", ExportReport.data.message);
  if (ExportReport.status === 201 && ExportReport.data?.data?.html) {
    const blob = new Blob([ExportReport.data.data.html], { type: 'text/html' });
    const fileUrl = URL.createObjectURL(blob);
    window.open(fileUrl, "_blank");
    SuccessToast("Event entries print view opened.");
    return true;
  } else {
    if (ExportReport.status === 401) HandleLogout();
    else if (ExportReport.status === 400 || ExportReport.status === 201) {
      ErrorToast(ExportReport.data?.message || "No entries or automation data found to download.");
    } else {
      ErrorToast(ExportReport.data?.message || "Something went wrong please try again later");
    }
    return null;
  }
};

export default handleExportReport;
